import React from "react";
import PropTypes from "prop-types";
import Notification from "./Notification";

export default function NotificationsManager({ setNotify }) {
  const [notifications, setNotifications] = React.useState([]);
  const nextId = React.useRef(0); // Step 1: Use a ref for unique IDs

  const createNotification = ({ color, autoClose, children }) => {
    const id = nextId.current++; // Generate unique ID
    setNotifications((prevNotifications) => [
      ...prevNotifications,
      { id, children, color, autoClose }, // Include ID in notification object
    ]);
  };

  React.useEffect(() => {
    setNotify(({ color, autoClose, children }) =>
      createNotification({ color, autoClose, children })
    );
  }, [setNotify]);

  const deleteNotification = (id) => { // Step 2: Delete by ID
    setNotifications((prev) => prev.filter((notification) => notification.id !== id));
  };

  return notifications.map(({ id, ...props }) => (
    <Notification
      key={id}
      onDelete={() => deleteNotification(id)} // Step 3: Pass ID to handler
      {...props}
    />
  ));
}

NotificationsManager.propTypes = {
  setNotify: PropTypes.func.isRequired,
};